import { validationMessages } from '../../../app/utils/validationMessages';

import { Link } from "react-router-dom";
import { updateProfileWithRefLink } from "../../../app/utils/util";

const RequestFormModel = {
  RequestPortalAccess: {
    IAm: {
      name: 'IAm',
      label: 'I am'
    },
    FurtherDetails: {
      name: 'FurtherDetails',
      label: 'Further details',
      maxStringCount: 1500,
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  ReductionsAndExemptions: {
    DiscountTypeOrExemption: {
      name: 'DiscountTypeOrExemption',
      label: 'Please select the type of discount or exemption you are requesting*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    DateOfReturnFromParentalLeave: {
      name: 'DateOfReturnFromParentalLeave',
      label: 'If you are applying for the parental leave exemption, please provide a date of return (month or year)',
      maxStringCount: 100,
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    InfoForRequest: {
      name: 'InfoForRequest',
      label: 'Would you like to provide any additional information about your request?',
      maxStringCount: 1500,
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  Merchandise: {
    MerchandiseAreTheDetailsCorrect: {
      name: 'MerchandiseAreTheDetailsCorrect',
      label: <>
        I confirm my profile details are up-to-date <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }}
          to={updateProfileWithRefLink()}>(please check my profile)</Link>.
      </>,
      labelText: 'I confirm my profile details are up-to-date.',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    },
    MerchandiseRequestDetails: {
      name: 'MerchandiseRequestDetails',
      label: 'Merchandise request details*',
      maxStringCount: 1500,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  LinkedIn: {
    LinkedInAreTheDetailsCorrect: {
      name: 'LinkedInAreTheDetailsCorrect',
      label: <>
        I wish to join the private RCSI Fellows and Members LinkedIn Group and confirm
        that I have updated <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} to={updateProfileWithRefLink()}>my profile</Link> with my LinkedIn account.
      </>,
      labelText: 'I wish to join the private RCSI Fellows and Members LinkedIn Group and confirm that I have updated my profile with my LinkedIn account.',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    }
  },
  PasTest: {
    PasTestAreTheDetailsCorrect: {
      name: 'PasTestAreTheDetailsCorrect',
      label: <>
        I wish to receive information regarding discounted access for PasTest and I confirm my
        profile details are up-to-date <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} to={updateProfileWithRefLink()}>(please check my profile)</Link>.
      </>,
      labelText: 'I wish to receive information regarding discounted access for PasTest and I confirm my profile details are up-to-date (please check my profile).',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    }
  },
  AcessCardFellowAndMember: {
    AcessCardFellowAndMemberAreTheDetailsCorrect: {
      name: 'AcessCardFellowAndMemberAreTheDetailsCorrect',
      label: <>
        I would like to request a campus access card and confirm my profile details are up-to-date (please check
        <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} to={updateProfileWithRefLink()}> my profile</Link>).
      </>,
      labelText: 'I would like to request a campus access card and confirm my profile details are up-to-date (please check my profile).',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    }
  },
  AcessCardAlumni: {
    AcessCardAlumniAreTheDetailsCorrect: {
      name: 'AcessCardAlumniAreTheDetailsCorrect',
      label: <>
        I would like to request a campus access card and confirm my profile details are up-to-date (please check
        <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} to={updateProfileWithRefLink()}> my profile</Link>).
      </>,
      labelText: 'I would like to request a campus access card and confirm my profile details are up-to-date (please check my profile).',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    }
  },
  ClassNotes: {
    PersonalProfessionalUpdates: {
      name: 'PersonalProfessionalUpdates',
      label: 'Personal/professional updates*',
      maxStringCount: 1500,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    ClassNotesAreTheDetailsCorrect: {
      name: 'ClassNotesAreTheDetailsCorrect',
      label: <>
        I confirm my profile details are up-to-date (please check
        <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} to={updateProfileWithRefLink()}> here</Link>).
      </>,
      labelText: 'I confirm my profile details are up-to-date.',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    }
  },
  ContactClassmates: {
    DetailsOfClassmate: {
      name: 'DetailsOfClassmate',
      label: 'Details of classmate*',
      maxStringCount: 1500,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    ContactClassmatesAreTheDetailsCorrect: {
      name: 'ContactClassmatesAreTheDetailsCorrect',
      label: <>
        I confirm my profile details are up-to-date (please check<Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} to={updateProfileWithRefLink()}> here</Link>).
      </>,
      labelText: 'I confirm my profile details are up-to-date.',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    }
  },
  Yearbook: {
    YearbookAreTheDetailsCorrect: {
      name: 'YearbookAreTheDetailsCorrect',
      label: <>
        I would like to request a digital copy of my yearbook and confirm
        <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} to={updateProfileWithRefLink()}> my profile</Link> details are up-to-date.
      </>,
      labelText: 'I would like to request a digital copy of my yearbook and confirm my profile details are up-to-date.',
      requiredErrorMsg: 'Please confirm your details are up-to-date.'
    }
  },
  Tours: {
    NoOfAttendees: {
      name: 'NoOfAttendees',
      label: 'No. of attendees*',
      minValueErrorMsg: 'At least 1 attendee is required.',
      maxValueErrorMsg: 'Maximum 20 attendees are allowed.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    PreferredDate1: {
      name: 'PreferredDate1',
      label: 'Preferred date 1*',
      get minErrorMsg(): string {
        return `${this.label.replace('*', '')} should be within 10 days range from today.`;
      },
      get maxErrorMsg(): string {
        return `${this.label.replace('*', '')} should be within 10 days range from today.`;
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    PreferredDate2: {
      name: 'PreferredDate2',
      label: 'Preferred date 2'
    },
    PreferredDate3: {
      name: 'PreferredDate3',
      label: 'Preferred date 3'
    }
  },
  VolunteerRequest: {
    CurrentRole: {
      name: 'CurrentRole',
      label: 'Current role (student or faculty)*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    DepartmentIfFacultyOrSocietyClubIfStudent: {
      name: 'DepartmentIfFacultyOrSocietyClubIfStudent',
      label: 'Department (if faculty) / Society or Club (if student)*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    TypeOfVolunteeringRequired: {
      name: 'TypeOfVolunteeringRequired',
      label: 'Type of volunteering required*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    NumberOfVolunteersRequired: {
      name: 'NumberOfVolunteersRequired',
      label: 'How many volunteers are required?*',
      minErrorMsg: 'Number of volunteers must be a positive number.',
      typeErrorMsg: 'Number of volunteers must be a numeric value.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    DateAndTimeOfVolunteering: {
      name: 'DateAndTimeOfVolunteering',
      label: 'Date and time of volunteering*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    DurationOfVolunteeringInHours: {
      name: 'DurationOfVolunteeringInHours',
      label: 'Duration of volunteering (in hours)*',
      get minErrorMsg(): string {
        return `${this.label.replace('*', '')} must be a positive number.`;
      },
      get typeErrorMsg(): string {
        return `${this.label.replace('*', '')} must be a numeric value.`;
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    IsVolunteeringOnlineInPerson: {
      name: 'IsVolunteeringOnlineInPerson',
      label: 'Is volunteering online/in-person?*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Discipline: {
      name: 'Discipline',
      label: 'Discipline*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    AreaOfPractice: {
      name: 'AreaOfPractice',
      label: 'Area of practice*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    CareerRange: {
      name: 'CareerRange',
      label: 'Career range*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Location: {
      name: 'Location',
      label: 'Location*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    WhatAreYouAskingThemToDoDeliverOn: {
      name: 'WhatAreYouAskingThemToDoDeliverOn',
      label: 'What are you asking them to do/deliver on?'
    },
    AnyAdditonalInfo: {
      name: 'AnyAdditonalInfo',
      label: 'Any additional information?'
    },
    ReferenceForVolunteringJob: {
      name: 'ReferenceForVolunteringJob',
      label: 'Do you have a specific individual(s) in mind for this volunteering ask? If so, please provide the name and class year of the individual(s).'
    }
  },
  ChangeOfName: {
    UpdatedName: {
      name: 'UpdatedName',
      label: 'Updated name*',
      maxStringCount: 1500,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  RequestToWithdraw: {
    Reason: {
      name: 'Reason',
      label: 'Reason*',
      maxStringCount: 1500,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  AbsenceFromPractice: {
    TypeOfLeave: {
      name: 'TypeOfLeave',
      label: 'Type of leave*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    AbsenceFromPracticeDateFrom: {
      name: 'AbsenceFromPracticeDateFrom',
      label: 'Date from*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    DateTo: {
      name: 'DateTo',
      label: 'Date to*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    }
  }
};

export default RequestFormModel;
